export const adminRoleName: string = 'Admin'
export const guestRoleName: string = 'Guest User'
export const updateUserSuccess: string = 'User updated'
export const updateUserEmail: string =
  'Update successful. A confirmation email has been sent to the new email address.'
export const activeUserDefault: string =
  'Inactive users will not utilize a license and they will not be able to access Sales Center. Closed records may stay assigned to inactive users for reporting purposes.'
export const activeUserLicensing: string =
  'No available licenses remaining. Cannot activate this user.'
export const activeUserRecords: string =
  'A user assigned to open records cannot be deactivated.'
export const activeUserEmailInUse: string =
  'Email is already in use. Cannot activate this user.'
export const activeUserUserOccupied: string =
  'PestPac User Id is already in use. Cannot activate this user.'
export const activeUserUserDeactivated: string =
  'User is not active in PestPac. Cannot activate this user.'
export const activeUserSuperAdmin: string =
  'Cannot deactivate a super administrator.'
export const inactiveUserUtilize: string =
  'Inactive users will not utilize a license and they will not be able to access Sales Center. Closed records may stay assigned to inactive users for reporting purposes.'
export const salesTeamNoPosition: string =
  'Sales Team has no positions. Select a Sales Team with a position, or add positions to this Sales Team.'
export const unmappedEmployeeTimeZone: string =
  "Unmapped employees inherit the timezone from the Company setting in PestPac's Timezone Manager."
export const userDisabledCoreProduct: string =
  'This user is unable to access Sales Center because they were deactivated in PestPac. You can reactivate them in PestPac or deactivate them in Sales Center to free up this license.'
export const userNoAccess: string = 'User has no access'
